export default "__VITE_ASSET__C6QIGm4l__"